import store from '@/store'
import { Action, config, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import Decisions from "@/store/modules/Decisions";
import _ from "lodash";
import { AppModel } from '@/api/model/AppModel';
import { v4 as uuidv4 } from 'uuid';
import { Decision } from '@/api/model/Decision';
import Vue from 'vue';
import { Urls } from "@/Urls";


config.rawError = true

const name = 'apps';

if (module.hot) {
    if (store.hasModule(name)) {
        store.unregisterModule(name);
    }
}

@Module({ dynamic: true, store, name: name })
export default class Apps extends VuexModule {
    // array of apps

    apps: any = [];
    marketplaceItems: any = [];
    appTemplateDetails: any = [];
    decisionTemplateDetails: any = [];
    // selected id
    selectedAppId: string = "";
    // index: number = 0;
    // openItems
    openAppNodes: any = [];
    currentAppUrl: string = "";
    activeItem: any = null;
    activeAppMenuId: any = "";
    activeAppMenuName: string = "";
    selectionMenu: boolean = false;
    viewpointSelectionMenu: boolean = false;
    choiceSelectionMenu: boolean = false;
    factorSelectionMenu: boolean = false;

    savedStates: any = [];

    get appTemplateDetailsDictionary() {
        return _.keyBy(this.appTemplates, 'id');
    }

    get decisionTemplateDetailsDictionary() {
        return _.keyBy(this.decisionTemplates, 'decisionIdRef');
    }

    get appTemplates() {
        return this.marketplaceItems.filter(app => app.type === "APP");
    }

    get appTemplatesDict() {
        return _.keyBy(this.appTemplates, 'appIdRef');
    }

    get decisionTemplates() {
        return this.marketplaceItems.filter(app => app.type === "TEMPLATE");
    }

    get decisionTemplatesDict() {
        return _.keyBy(this.decisionTemplates, 'decisionIdRef');
    }

    get appId() {
        return this.selectedAppId;
    }

    get appsActiveItem() {
        return this.activeItem;
    }

    get appName() {
        let name = "";
        let item = [{ name: "" }];
        if (this.apps.length) {
            item = _.filter(this.apps, { 'id': this.selectedAppId });
            // console.log('item');
            // console.log(item);
        }
        return item.length ? item[0].name : "";
    }

    get selectOpenAppNodes() {
        return this.openAppNodes;
    }


    get appsCurrentAppUrl() {
        return this.currentAppUrl;
    }

    // get array of apps
    get appList() {
        return this.apps;
    }

    // get dictionary of apps
    get appsDictionary() {
        let apps = _.keyBy(this.apps, 'id');
        return apps;
    }

    get marketPlaceDictionary() {
        let marketApps = _.keyBy(this.marketplaceItems, 'id');
        return marketApps;
    }

    get selectedDecisionId() {
        return getModule(Decisions).selectedDecisionId;
    }

    /* Depreciated */
    @Mutation
    setSelectionMenu(selectionMenu: boolean) {
        this.selectionMenu = selectionMenu;
    }

    @Mutation
    setViewpointSelectionMenu(viewpointSelectionMenu: boolean) {
        this.viewpointSelectionMenu = viewpointSelectionMenu;
    }

    @Mutation
    setChoiceSelectionMenu(choiceSelectionMenu: boolean) {
        this.choiceSelectionMenu = choiceSelectionMenu;
    }

    @Mutation
    setFactorSelectionMenu(factorSelectionMenu: boolean) {
        this.factorSelectionMenu = factorSelectionMenu;
    }

    @Mutation
    setActiveAppMenuName(activeName: string) {
        this.activeAppMenuName = activeName;
    }

    @Mutation
    setActiveAppMenuId(activeId: any) {
        this.activeAppMenuId = activeId;
    }

    @Mutation
    setAppTemplateDetails(appTemplateDetails: any) {
        this.appTemplateDetails = appTemplateDetails;
    }

    @Mutation
    setDecisionTemplateDetails(decisionTemplateDetails: any) {
        this.decisionTemplateDetails = decisionTemplateDetails;
    }

    @Mutation
    setMenuURL( payload: { menuId: string, url: string} ) {
        this.savedStates[payload.menuId] = payload.url.replace(Urls.APP_EMBED+'/', '/');
    }

    @Action
    async setMenuState(payload: { menuId: string, url: string}) {
        if (payload.menuId && payload.menuId != '') {
            this.setMenuURL(payload);
        }
    }

    @Action
    async selectActiveAppMenuName(id: any) {
        if (id < 0) {
            this.setActiveAppMenuName('');
            return null;
        }
        if (this.appsDictionary && this.appId && this.appsDictionary[this.appId]) {
            let appMenu = await this.findAppMenuById({ id: id, app: this.appsDictionary[this.appId] });
            if (appMenu) {
                this.setActiveAppMenuName(appMenu.name);
            }
        }
    }

    @Action
    async findAppMenuById(data) {
        if (data.app) {
            if (data.app.id === data.id) {
                return data.app;
            }
            if (data.app.children && data.app.children.length > 0) {
                for (let child of data.app.children) {
                    let found = await this.findAppMenuById({ id: data.id, app: child });
                    if (found) {
                        return found;
                    }
                }
            }
        }
        return null;
    }
    @Mutation
    setActiveItem(activeItem: any) {
        this.activeItem = activeItem;
    }

    @Action
    selectActiveItem(activeItem: any) {
        if (activeItem) {
            this.setActiveAppMenuId(activeItem.id);
            this.setActiveAppMenuName(activeItem.name);
            this.setActiveItem(activeItem);
        }
    }

    @Mutation
    setCurrentAppUrl(url: string) {
        this.currentAppUrl = url;
    }

    @Mutation
    setSelectOpenAppNodes(val: any) {
        this.openAppNodes = val;
    }

    @Mutation
    setSelectedAppId(appId: string) {
        this.selectedAppId = appId;
    }

    @Mutation
    setApps(apps: any) {
        this.apps = apps;
    }

    @Mutation
    setMarketplaceItems(apps: any) {
        this.marketplaceItems = apps;
    }

    @Action
    async fetchApps() {
        return await VIEWPOINT_API.getApps(this.selectedDecisionId)
            .then((res: any) => {
                if (res && res.length > 0 && !this.activeItem) {
                    this.setSelectedAppId(res[0].id);
                } else {
                    this.setSelectedAppId('');
                }
                let apps = res;
                // this.addIdToApps(apps);
                this.setApps(apps);
            });
    }

    @Action
    async fetchMarketplaceItems() {
        return await VIEWPOINT_API.getAllMarketplaceItems()
            .then((res: any) => {
                //    console.log(res)
                let apps = res;
                // if (res) {
                //     this.getMarketItemsDetails(res);
                // }
                // this.addIdToApps(apps);
                this.setMarketplaceItems(apps);
            });
    }

    @Action
    async getMarketItemsDetails(marketplaceItems: any[]) {
        let appTemplateDetails = [];
        let decisionTemplateDetails = [];
        for (let item of marketplaceItems) {
            if (item.type === "APP") {
                let appTemplateDetail = await VIEWPOINT_API.getApp(item.decisionIdRef, item.appIdRef);
                appTemplateDetails.push(appTemplateDetail);
            } else {
                let decisionTemplateDetail = await VIEWPOINT_API.getDecision(item.decisionIdRef);
                decisionTemplateDetails.push(decisionTemplateDetail);
            }
        }
        this.setDecisionTemplateDetails(decisionTemplateDetails);
        this.setAppTemplateDetails(appTemplateDetails);
        // console.log(marketplaceItemsDetails);
    }

    @Action
    async Apps() {
        return await VIEWPOINT_API.getApps(this.selectedDecisionId)
            .then((res: any) => {
                if (res && res.length > 0 && !this.activeItem) {
                    this.setSelectedAppId(res[0].id);
                } else {
                    this.setSelectedAppId('');
                }
                let apps = res;
                // this.addIdToApps(apps);
                this.setApps(apps);
            });
    }

    @Action
    async selectAppMenuById(id: string) {
        if (!id || id === '') return;
        this.setActiveAppMenuId(id);
        //let activeItem = [];
       // activeItem.push(id);
        this.selectActiveAppMenuName(id);
       // this.setActiveItem(activeItem);
    }

    @Action
    async fetchAppsByDecision(decisionId: string) {
        await VIEWPOINT_API.getApps(decisionId)
            .then((res: any) => {
                if (res && res.length > 0 && !this.activeItem) {
                    this.setSelectedAppId(res[0].id);
                } else {
                    this.setSelectedAppId('');
                }
                let apps = res;
                // this.addIdToApps(apps);
                this.setApps(apps);
            });
    }

    @Action
    async checkAppsByDecision(decisionId: string) {
        return await VIEWPOINT_API.getApps(decisionId)
    }

    @Action
    async createApp(params: { decisionId: any, app: AppModel }) {
        await VIEWPOINT_API.createApp(params.decisionId, params.app).then((res: any) => {
            this.setSelectedAppId(res.id);
            this.fetchAppsByDecision(params.decisionId);
        }).catch((err: any) => {
            console.log(err);
        });
    }


    /**
     * Create new app template
     * @param params
     * @param decisionIdRef - original decision id for reference
     * @param name - name of the app
     * @param appIdRef - original app reference id
     * @returns  
     */
    @Action
    async createAppTemplate(params: { decisionIdRef: string, app: any }) {
        let app = {
            appIdRef: params.app.id,
            decisionIdRef: params.decisionIdRef,
            name: params.app.name,
            type: "APP",
            userId: {},
            children: params.app.children || undefined,
            description: params.app.description || undefined,
            icon: params.app.icon || undefined,
            logo: params.app.logo || undefined,
            homepage: params.app.homepage || undefined,
            imageMain: params.app.imageMain || undefined,
            tags: params.app.tags || undefined,
            rating: params.app.rating || undefined,
            cta: params.app.cta || undefined,
            previewUrl: params.app.previewUrl || undefined,
            subscriptionStatus: params.app.subscriptionStatus,
            showHomepage: params.app.showHomepage || undefined,
        }
        return await VIEWPOINT_API.createApp('PUBLIC', app);
    }

    @Action
    async createTemplate(params: { decisionId: string, payload: Decision }) {
        let res = await VIEWPOINT_API.createTemplate(params.decisionId, params.payload.name, (params.payload.description || undefined), (params.payload.choiceLabel || undefined), (params.payload.viewpointLabel || undefined), (params.payload.factorLabel || undefined), (params.payload.pluralChoiceLabel || undefined), (params.payload.pluralViewpointLabel || undefined), (params.payload.pluralFactorLabel || undefined), (params.payload.scoringSuffix || '%'), (params.payload.scoringRangeMax || 100), (params.payload.templateApproved || false), (params.payload.templateEnabled || false), (params.payload.templatePriceMonthly != null? params.payload.templatePriceMonthly: 0), params.payload.stripeProductCode)
        await this.fetchMarketplaceItems()
        return res;
    }

    @Action
    async addUserToApp(payload: { id: string, userId: string }) {
        let cloneApp = _.cloneDeep(this.marketPlaceDictionary[payload.id]);
        console.log(cloneApp)
        if (payload.userId === undefined) {
            return;
        }
        if (cloneApp && cloneApp.userIds && !(payload.userId in cloneApp.userIds)) {
            Vue.set(cloneApp.userIds, payload.userId, { licenseKey: '', licenseValid: 1 })
        } else if (cloneApp && !('userIds' in cloneApp)) {
            let tempUserObject = {}
            Vue.set(tempUserObject, payload.userId, { licenseKey: '', licenseValid: 1 })
            Vue.set(cloneApp, 'userIds', tempUserObject)
        }
        console.log(cloneApp)
        await VIEWPOINT_API.updateApp('PUBLIC', cloneApp.id, cloneApp)
        this.fetchMarketplaceItems()
    }

    @Action
    async addUserToAppWithApp(payload: { app: any, userId: string }) {
        let cloneApp = _.cloneDeep(payload.app);
        console.log(cloneApp)
        if (cloneApp && cloneApp.userIds && !(payload.userId in cloneApp.userIds)) {
            Vue.set(cloneApp.userIds, payload.userId, { licenseKey: '', licenseValid: 1 })
        } else if (cloneApp && !('userIds' in cloneApp)) {
            let tempUserObject = {}
            Vue.set(tempUserObject, payload.userId, { licenseKey: '', licenseValid: 1 })
            Vue.set(cloneApp, 'userIds', tempUserObject)
        }
        console.log(cloneApp)
        await VIEWPOINT_API.updateApp('PUBLIC', cloneApp.id, cloneApp)
        this.fetchMarketplaceItems()
    }

    @Action
    async removeUserFromApp(payload: { id: string, userId: string }) {
        let cloneApp = _.cloneDeep(this.marketPlaceDictionary[payload.id]);
        console.log(cloneApp)
        let didAppChange = false
        if (cloneApp && cloneApp.userIds && (payload.userId in cloneApp.userIds)) {
            Vue.delete(cloneApp.userIds, payload.userId)
            didAppChange = true
        }
        console.log(cloneApp)
        if (didAppChange)
            await VIEWPOINT_API.updateApp('PUBLIC', cloneApp.id, cloneApp)
        this.fetchMarketplaceItems()
    }


    /**
     * function to update an app template directly
     * @param params 
     * @param appTemplate app template to be updated
     * @param app app from the current decision
     * 
     */

    @Action
    async updateAppTemplate(params: {appTemplate:any, app:any}){
        let appTemplate: AppModel = {
            id: params.appTemplate.id,
            appIdRef: params.app.id,
            decisionIdRef: params.appTemplate.decisionIdRef,
            name: params.app.name,
            children: params.app.children || undefined,
            description: params.app.description || undefined,
            icon: params.app.icon || undefined,
            logo: params.app.logo || undefined,
            homepage: params.app.homepage||undefined,
            imageMain: params.app.imageMain || undefined,
            tags: params.app.tags || undefined,
            rating: params.app.rating || undefined,
            cta: params.app.cta || undefined,
            previewUrl: params.app.previewUrl || undefined,
            subscriptionStatus: params.app.subscriptionStatus,
            showHomepage: params.app.showHomepage || undefined,
            tileViewImage: params.app.tileViewImage || undefined,
            userPermission: params.app.userPermission || undefined,
            type: "APP",
            userId: params.appTemplate.userId
        }
        console.log(appTemplate);
        return await VIEWPOINT_API.updateApp('PUBLIC', appTemplate.id, appTemplate)
    }

    /**
     * Actions updatesApps, this could be used to update the app for decision and template apps
     * The difference are the parameter are different
     * @param params 
     */
    @Action
    async updateApps(params: { decisionId: string, appId: string, app: any }) {
        let app = params.app
        app.decisionIdRef = params.decisionId
        await VIEWPOINT_API.updateApp(params.decisionId, params.appId, params.app).then((res: any) => {
            // this.setSelectedAppId(params.app.id);
            let apps = _.cloneDeep(this.apps);
            for (let item of apps) {
                if (item.id === res.id) {
                    item = _.cloneDeep(res);
                }
            }
            this.setApps(apps);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    @Action
    async updateTemplate(params: { decisionId: string, appId, app: Decision }) {

        await VIEWPOINT_API.updateApp(params.decisionId, params.appId, params.app).then((res: any) => {
            // this.setSelectedAppId(params.app.id);
            let apps = _.cloneDeep(this.apps);
            for (let item of apps) {
                if (item.id === res.id) {
                    item = _.cloneDeep(res);
                }
            }
            this.fetchMarketplaceItems();
        }).catch((err: any) => {
            console.log(err);
        });
    }

    @Action
    async deleteApps(params: { decisionId: string, appId: string }) {
        await VIEWPOINT_API.deleteApp(params.decisionId, params.appId).then((res: any) => {
            this.setSelectedAppId('');
            this.fetchAppsByDecision(params.decisionId);
            this.fetchMarketplaceItems()
        }).catch((err: any) => {
            console.log(err);
        });
    }

    @Action
    async installApp(app: any) {
        let cloneDecision = _.cloneDeep(app)
        // clone the ORIGINAL SOURCE Decision (based on decisionIdRef) into that User's owned Decisions
        let decisionModule = getModule(Decisions)
        cloneDecision.decisionTemplateId = app.decisionIdRef
        let result = await decisionModule.copyIntoNewDecision(cloneDecision)
        await this.createAppIds({ newDecisionId: result.decision.decisionId, oldDecision: app.decisionIdRef })
    }

    //This creates new apps with decisionRef of the provided decision
    @Action
    async createAppIds(payload: { newDecisionId: string, oldDecision: string }) {
        let oldDecAppLIst = await VIEWPOINT_API.getApps(payload.oldDecision)
        for (let app of oldDecAppLIst) {
            let tempApp = _.cloneDeep(app)
            Vue.set(tempApp, 'appIdRef', app.id)
            Vue.set(tempApp, 'decisionIdRef', payload.oldDecision)
            Vue.set(tempApp, 'type', 'APP')
            // Vue.set(tempApp, 'decisionId', )
            console.log(tempApp)
            await VIEWPOINT_API.createApp(payload.newDecisionId, tempApp)
        }
        this.fetchApps()
    }

    // obsolete - id will be saved in the database now
    @Action
    async addIdToApps(apps: any[]) {
        if (apps && apps.length > 0) {
            // this.setIndex(0);
            apps.forEach(async app => {
                if (app.hasOwnProperty('children') && app.children.length > 0) {
                    let idAdded = this.addIdToChilren(app.children);
                    if (idAdded) {
                        await this.updateApps({ decisionId: this.selectedDecisionId, appId: app.id, app: app });
                    }
                }
            });
        }
    }

    // obsolete - id will be saved in the database now
    // add id to chilren
    @Action
    addIdToChilren(children: any[]) {
        let idAdded = false
        children.forEach(child => {
            if (!child.hasOwnProperty('id')) {
                child.id = uuidv4();
                idAdded = true;
            }
            // child.id = this.index;
            // this.indexIncrement();
            if (child.hasOwnProperty('children') && child.children.length > 0) {
                let childrenIdAdded = this.addIdToChilren(child.children);
                if (childrenIdAdded) {
                    idAdded = true;
                }
            }
        });
        return idAdded;
    }

    // obsolete - id will be saved in the database now
    @Action
    removeIdFromApp(children: any[]) {
        children.forEach(child => {
            delete child.id;
            if (child.hasOwnProperty('children') && child.children.length > 0) {
                this.removeIdFromApp(child.children);
            }
        });
    }

}
